import { Component, HostBinding, Input, OnInit, OnChanges, Output, EventEmitter, Renderer2, ElementRef } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from '../../../../../shared/services/nav.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SStorageService } from 'src/app/shared/services/sessionStorage.service';

@Component({
  selector: 'app-nav-item',
  imports: [TranslateModule, TablerIconsModule, MaterialModule, CommonModule],
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)'))
    ])
  ]
})
export class AppNavItemComponent implements OnChanges, OnInit {
  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedIcon: string;
  expanded: any = false;
  disabled: any = false;
  twoLines: any = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @HostBinding('style.--mod-color') get modColor() {
    return this.item?.color ?? null;
  }
  @HostBinding('class.nivel-modulo') get esModulo() {
    return !this.depth && !this.item?.navCap && !!this.item?.color;
  }
  @HostBinding('class.con-color') get conColor() {
    return !!this.item?.color;
  }
  @Input() item: NavItem | any;
  @Input() depth: any;

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    public navService: NavService,
    public router: Router,
    public sstorageService: SStorageService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    // Aplicar indentación basada en depth
    if (this.depth > 0) {
      this.renderer.addClass(this.elementRef.nativeElement, 'indented-item');
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', `${this.depth * 10}px`);
    }
  }

  ngOnChanges() {
    const url = this.navService.currentUrl();
    if (this.item.route && url) {
      this.expanded = url.indexOf(`/${this.item.route}`) === 0;
      this.ariaExpanded = this.expanded;
    }
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.sstorageService.setItem('url', item.route);
      this.sstorageService.setItem('mod', item.id);
      this.router.navigate([item.route]);
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
    //scroll
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    if (!this.expanded) {
      if (window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }

  onSubItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (this.expanded && window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }
}
